import classNames from 'classnames';
import React from 'react';
import Portal from '../Portal/Portal';

interface IDrawerProps {
  direction?: 'left' | 'right' | 'top' | 'bottom';
  open?: boolean;
  className?: string;
  target?: string;
  zIndexClassName?: string;
  disableBackdropClose?: boolean;
  hideBackdrop?: boolean;
  onClose?: (e?: any) => void;
}

const Drawer: React.FC<React.PropsWithChildren<IDrawerProps>> = ({
  direction = 'right',
  open,
  className = 'w-full',
  target,
  onClose,
  zIndexClassName = 'z-10',
  disableBackdropClose,
  hideBackdrop,
  children,
}) => {
  return (
    <Portal target={target}>
      {/* backdrop */}
      {open && !hideBackdrop && (
        <div
          className={classNames(
            'fixed inset-0 bg-gray-300 bg-opacity-50 backdrop-blur-20',
            zIndexClassName
          )}
          onClick={(!disableBackdropClose && onClose) || undefined}
        />
      )}
      <div
        className={classNames(
          'p-5 fixed transform transition-transform duration-500',
          zIndexClassName,
          className,
          {
            'bg-white': !className?.includes('bg'),
            'h-full top-0 right-0 overflow-x-hidden overflow-y-auto':
              direction === 'right',
            'translate-x-full': direction === 'right' && !open,
            'translate-x-0': direction === 'right' && open,
          }
        )}
      >
        {children}
      </div>
    </Portal>
  );
};
export default Drawer;
